(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["woodart-complete-look"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-section-id^="CompleteLook-"]').forEach(function(section){
    var button=section.querySelector('[data-complete-look-add]');
    var status=section.querySelector('[data-complete-look-status]');
    if(!button)return;
    function selectedCount(){
      var quantityChoice=document.querySelector('input[name="vp_qty"]:checked');
      var baseQuantity=quantityChoice?Number(quantityChoice.value||1):1;
      return baseQuantity+section.querySelectorAll('[data-complete-look-check]:checked').length;
    }
    function updateOfferStatus(){
      if(!status)return;
      var count=selectedCount();
      var remaining=Math.max(0,4-count);
      status.textContent=remaining===0?'مبروك! خصم 10% هيتطبق تلقائيًا على الأربع قطع أو أكثر.':'متبقي '+remaining+' قطعة لتفعيل خصم 10%.';
    }
    section.querySelectorAll('[data-complete-look-check]').forEach(function(check){check.addEventListener('change',updateOfferStatus)});
    document.querySelectorAll('input[name="vp_qty"]').forEach(function(choice){choice.addEventListener('change',updateOfferStatus)});
    updateOfferStatus();
    button.addEventListener('click',async function(){
      var items=[];
      var counts={};
      var quantityChoice=document.querySelector('input[name="vp_qty"]:checked');
      var baseQuantity=quantityChoice?Number(quantityChoice.value||1):1;
      if(baseQuantity>1){
        for(var i=1;i<=baseQuantity;i++){
          var piece=document.querySelector('input[name="vp_piece_'+i+'"]:checked');
          if(piece)counts[piece.value]=(counts[piece.value]||0)+1;
        }
      }
      if(!Object.keys(counts).length){
        var selectedBase=document.querySelector('input[name="vp_variant"]:checked');
        var baseId=selectedBase?selectedBase.value:section.dataset.baseVariant;
        counts[baseId]=baseQuantity;
      }
      Object.keys(counts).forEach(function(id){items.push({id:Number(id),quantity:counts[id]})});
      section.querySelectorAll('[data-complete-look-check]:checked').forEach(function(check){
        var card=check.closest('.complete-look__card');
        var variant=card?card.querySelector('[data-complete-look-variant]'):null;
        if(variant&&variant.value)items.push({id:Number(variant.value),quantity:1});
      });
      var original=button.textContent;
      button.disabled=true;
      button.textContent='جاري إضافة المجموعة...';
      try{
        var response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})});
        if(!response.ok)throw new Error('cart');
        window.location.href='/cart';
      }catch(error){
        if(status)status.textContent='حصلت مشكلة بسيطة، حاول مرة أخرى.';
        button.disabled=false;
        button.textContent=original;
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
